/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyAIAssistantOperatorListItem,
  PharmacyAIAssistantOperatorListItemFromJSON,
  PharmacyAIAssistantOperatorListItemFromJSONTyped,
  PharmacyAIAssistantOperatorListItemToJSON,
} from "./";

export const GetAIAssistantOperatorsResponseTypename = "GetAIAssistantOperatorsResponse" as const;

/**
 *
 * @export
 * @interface GetAIAssistantOperatorsResponse
 */
export interface GetAIAssistantOperatorsResponse {
  /**
   *
   * @type {PharmacyAIAssistantOperatorListItem}
   * @memberof GetAIAssistantOperatorsResponse
   */
  aiAssistantOperator: PharmacyAIAssistantOperatorListItem;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetAIAssistantOperatorsResponse
   */
  readonly __typename?: string;
}

export function GetAIAssistantOperatorsResponseFromJSON(json: any): GetAIAssistantOperatorsResponse {
  return GetAIAssistantOperatorsResponseFromJSONTyped(json, false);
}

export function GetAIAssistantOperatorsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetAIAssistantOperatorsResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetAIAssistantOperatorsResponseTypename,

    aiAssistantOperator: PharmacyAIAssistantOperatorListItemFromJSON(json["ai-assistant-operator"]),
  };
}

export function GetAIAssistantOperatorsResponseToJSON(object?: GetAIAssistantOperatorsResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    "ai-assistant-operator": PharmacyAIAssistantOperatorListItemToJSON(value.aiAssistantOperator),
  };
}
